import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const EXPORT_CONTACTS = "EXPORT_CONTACTS";
export const CLEAR_EXPORTS_ERRORS = "CLEAR_EXPORTS_ERRORS";

// mutation types
export const SET_EXPORTS_ERROR = "setExportsError";
export const REMOVE_EXPORTS_ERRORS = "removeExportsErrors";

const state = {
    errors: null
};
const actions = {
    [EXPORT_CONTACTS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/exportcontacts", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_EXPORTS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_EXPORTS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_EXPORTS_ERRORS](context) {
        context.commit(REMOVE_EXPORTS_ERRORS);
    },
};

const mutations = {
    [SET_EXPORTS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_EXPORTS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
